export const DefaultTheme = {
  title: "DefaultTheme",

  colors: {
    primary: "#007EBB",
    secondary: "#EC7722",

    background: "#FFFFFF",
    backgroundGray: "#F0F0F0",

    textWhite: "#FFFFFF",
    textBlack: "#333333",
  },

  fontSize: {
    extraSmall: "14px",
    small: "16px",
    medium: "18px",
    large: "20px",
    extraLarge: "22px",
    extraLarge2: "60px",
    title: "28px",
    extraTitle: "36px",
  },

  borderRadius: "4px",
  transition: "all .2s",
  margin: "0px 45px 10px 45px",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",

  // Media Query
  media: {
    desktop: "@media(min-width: 1216px)",
    mobile: "@media (max-width: 768px)",
  },
};
